const federatedStates = ['AR', 'AU', 'AT', 'BE', 'BA', 'BR', 'CA', 'KM', 'ET', 'DE', 'IN', 'IQ', 'MY', 'MX', 'NP', 'NG', 'PK', 'RU', 'SD', 'SS', 'CH', 'AE', 'US', 'VE']

export default federatedStates
